import { Component, OnInit } from '@angular/core';
import { Widget } from 'src/app/shared/classes/Widget';
import { WidgetInjectedData } from 'src/app/shared/classes/WidgetInjectedData';
import { ButtonColorType } from 'src/app/shared/enums/ButtonColorType';
import { ButtonType } from 'src/app/shared/enums/ButtonType';
import { IconType } from 'src/app/shared/enums/IconType';
import { ModalType } from 'src/app/shared/enums/ModalType';
import { IIntegrationInput } from 'src/app/shared/interfaces/integration/IIntegrationInput';
import { IModalData } from 'src/app/shared/interfaces/modal/IModalData';
import { PlanOnboardingModalComponent } from '../../../modal-templates/account-onboarding-modals/plan-onboarding-modal/plan-onboarding-modal.component';

@Component({
    selector: 'app-plan-integration',
    templateUrl: './plan-integration.component.html',
    styleUrls: ['./plan-integration.component.sass']
})
export class PlanIntegrationComponent implements OnInit {
    integrationInput: IIntegrationInput = null;
    widgetRef: Widget;

    constructor(widgetData: WidgetInjectedData) {
        this.widgetRef = widgetData.widgetRef;
    }

    ngOnInit(): void {
        this.setUpBasics();
    }

    setUpBasics() {
        this.integrationInput = {
            integrationName: this.widgetRef.widgetData.widgetInfo.text,
            integrationCategory: 'Cloud Integration',
            imageUrl: 'assets/Azure-Plan.png',
            buttons: [
                {
                    buttonName: 'Add',
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Add Azure PLAN account',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-plus'
                    },
                    function: (buttonRef) => {
                        // Open Modal
                        this.onIntegrate(buttonRef);
                    }
                }
            ],
            imagePadding: 4
        };
    }
    onIntegrate(buttonRef: any) {
        const modalArgs: IModalData = {
            modalIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-chalkboard-teacher'
            },
            modalName: 'On Board Azure PLAN',
            modalType: ModalType.MIDDLE,
            sourceId: this.widgetRef.uniqueIdentity,
            extraStepContainerClass: 'remove-form-space',
            modalSteps: [
                {
                    stepName: 'Step 1',
                    resetModal: true,
                    stepData: {
                        componentToLoad: PlanOnboardingModalComponent,
                        payload: {
                            data: {
                                create: this.widgetRef.widgetData.widgetInfo
                                    .create,
                                widgetRef: this.widgetRef
                            }
                        }
                    }
                }
            ],
            modalWidthVw: 70,
            modalHeightVh: 85
        };
        this.widgetRef.modalService.openModal(modalArgs);
    }
}
